import { render, staticRenderFns } from "./InvoiceCarousel.vue?vue&type=template&id=15c01dfa&scoped=true&"
import script from "./InvoiceCarousel.vue?vue&type=script&lang=js&"
export * from "./InvoiceCarousel.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceCarousel.vue?vue&type=style&index=0&id=15c01dfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c01dfa",
  null
  
)

export default component.exports